export const NB_REVIEWS_DISPLAYED = 7
